import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import './index.less';
import Card from '../Card';
import { Tracker } from '@ali/react-util';
const { spmC } = Tracker;
import '../../utils/tooltipster/index';
import '../../utils/tooltipster/tooltipster.bundle.css';
import '../../utils/tooltipster/tooltipster-sideTip-shadow.min.css';

async function runPromiseByQueue(myPromises) {
  for (let value of myPromises) {
    await value();
  }
}
@spmC()
@inject('dashboardStore')
@observer
class CardContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }
  // 批量加入购物车
  addToCart = async () => {
    // 设置loading状态，现在获取的是全部产品，需要更改一下
    if (!this.props.dashboardStore.isLogin) {
      this.props.dashboardStore.handleNotLogin();
    } else {
      this.setState({
        loading: true
      });
      const goodsList = this.props.dashboardStore.cartIndex.map((item) => {
        return this.props.goods[item];
      });
      //console.log(goodsList,"goodsList");

      const requestList = goodsList.map(goods => {
        return async () => {
          await goods.product.addCart();
        };
      });
      await runPromiseByQueue(requestList);
      this.setState({
        loading: false
      });
      this.props.dashboardStore.clearCart();
    }
    // loading 结束
    // 清空已经选择的商品
  }
  //根据满减规则配置的映射关系
  leftPrice = (productCodeListLength) => {
    let firstRule = window.tms.moduleinfo.firstRule;
    if (productCodeListLength == 1) {
      return {
        leftPrice: firstRule.one.leftPrice,
        rightText: firstRule.one.rightText
      };
    } else if (productCodeListLength == 2) {
      return {
        leftPrice: firstRule.two.leftPrice,
        rightText: firstRule.two.rightText
      };
    } else if (productCodeListLength == 3) {
      return {
        leftPrice: firstRule.three.leftPrice,
        rightText: firstRule.three.rightText
      };
    } else if (productCodeListLength == 4) {
      return {
        leftPrice: firstRule.four.leftPrice,
        rightText: firstRule.four.rightText
      };
    } else if (productCodeListLength == 5 || productCodeListLength > 5) {
      return {
        leftPrice: firstRule.five.leftPrice,
        rightText: firstRule.five.rightText
      };
    } else {
      return {
        leftPrice: 0,
        rightText: '选2种产品，即可享受95折，最高可满减2500元',
      };
    }
  }

  async componentDidMount() {
    $('.card-list').each(function () {
      let title = $(this).children().text();
      if ($(this)[0].offsetWidth < $(this)[0].scrollWidth) {
        $(this).tooltipster({
          theme: 'tooltipster-shadow',
          delay: 100,
          content: title
        });
      }
    });
  }
  render() {
    let textArr = this.props.goods;
    textArr = textArr.filter(item => item.exts.keys && item.exts.keys.value); //去掉没有配置的项
    let textArrLength = textArr.length;
    const totalPrice = Number(this.props.dashboardStore.totalPrice).toFixed(2);
    const { totalProduct, loading } = this.props.dashboardStore;
    let leftPrice = this.props.dashboardStore.productCodeListLength;
    leftPrice = this.leftPrice(leftPrice); //得到满减规则映射关系的对象

    return (
      <div className="card-wrap">
        <p className="first-title">
          {window.tms.moduleinfo.fristFloor}
        </p>
        <div className="card-content">
          <div className="card-top">
            <img className="left-img" src="https://img.alicdn.com/tfs/TB14f6QAMHqK1RjSZFgXXa7JXXa-400-400.png" alt="" />
            <div className="card-left">
              <div className="card-title">{window.tms.moduleinfo.firstTitle}</div>
              <div className="card-list-wrap">
                <div className="card-left-list">
                  {window.tms.firstDescListLeft.map((item, index) => {
                    return (
                      <li className="card-list" key={index}>·<span className="left-point">{item.descLeft}</span></li>
                    );
                  })}
                </div>
                <div className="card-right-list">
                  {window.tms.firstDescListRight.map((item, index) => {
                    return (
                      <li className="card-list" key={index}>·<span className="left-point">{item.descRight}</span></li>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="card-right">
              <div className="card-title">优惠说明</div>
              <ul className="card-list-wrap">
                {window.tms.firstDiscountsExplainList.map((item, index) => {
                  return (
                    <li className="card-list"
                      key={index}><span className="point">{index + 1}、{item.discount}</span></li>
                  );
                })}
              </ul>
            </div>
          </div>
          <div className="card-bottom">
            <img className="right-img"
              src="https://img.alicdn.com/tfs/TB1dUnNAQvoK1RjSZFNXXcxMVXa-400-400.png" alt="" />
            <div className="card-module-top">
              {textArr.map((item, index) => {
                return (
                  <Card product={item.product} status={index} key={item.id}
                    exts={item.exts} productCode={item.productCode} goods={item} textArrLength={textArrLength} />
                );
              })}
            </div>
            <div className="card-module-bottom">
              <div className="card-module-bottom-left">
                <span className="first-small-title">
                  已选产品:</span><span className="first-small-desc">{totalProduct}</span>
                <span className="second-small-title">
                  最高可享满减:</span><span className="second-small-desc">￥{leftPrice.leftPrice}</span>
                <span className="third-btn">{leftPrice.rightText}</span>
              </div>
              <div className="card-module-bottom-right">
                <div className="card-module-inner-left">
                  <p className="cart-desc">合计:<span className="cart-num">
                    {loading ? <span>计算中...</span> : <span>￥{totalPrice}</span>}</span></p>
                  <p className="cart-second-desc">{window.tms.moduleinfo.firstCartExplain}</p>
                </div>
                {this.state.loading ?
                  <div className="card-module-inner-right">
                    加入中...
                  </div>
                  : <div className={`${totalProduct ? '' : 'gray'} card-module-inner-right`}
                    onClick={this.addToCart} data-spm-click="gostr=/aliyun;locaid=cart">
                    加入购物车
                  </div>}
              </div>
            </div>
          </div>
        </div>
        <p className="tips">
          {window.tms.moduleinfo.firstTips}<a className="jump"
            href={window.tms.moduleinfo.firstJumpUrl} target="_blank">{window.tms.moduleinfo.firstJumpTips}</a>
        </p>
      </div>
    );
  }
}

export default CardContent;


// WEBPACK FOOTER //
// ./src/scripts/components/CardContent/index.js